import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

export enum NotiType {
  Error,
  Success,
  Info,
  Warn,
}

export class NotiSheetData {
  public text: string;
  public type: NotiType;
  public timeout: number;
  public permanent: boolean;
  public confirmMode: boolean;
  public confirmText: string;
  public cancelText: string;

  constructor(
    text: string,
    type: NotiType,
    timeout: number,
    permanent: boolean = false,
    confirmMode: boolean = false,
    confirmText: string = 'Bestätigen',
    cancelText: string = 'Abbrechen'
  ) {
    this.text = text;
    this.type = type;
    this.timeout = timeout;
    this.permanent = permanent;
    this.confirmMode = confirmMode;
    this.confirmText = confirmText;
    this.cancelText = cancelText;
  }
}

@Component({
  selector: 'app-noti-bottom-sheet',
  templateUrl: './noti-bottom-sheet.component.html',
  styleUrls: ['./noti-bottom-sheet.component.css'],
})
export class NotiBottomSheetComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: NotiSheetData,
    private bottomSheetRef: MatBottomSheetRef<NotiBottomSheetComponent>
  ) {
    if (!data.permanent && !data.confirmMode) {
      setTimeout(() => {
        this.bottomSheetRef.dismiss();
      }, data.timeout);
    }
  }

  ngOnInit(): void {}

  onConfirm(): void {
    this.bottomSheetRef.dismiss(true);
  }

  onCancel(): void {
    this.bottomSheetRef.dismiss(false);
  }
}
